/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Keycloak Context
 */

import { createContext } from 'react';
import Keycloak, { KeycloakInitOptions, KeycloakLoginOptions } from 'keycloak-js';

export interface IKeycloakContext {
	isAuthenticated: boolean;
	keycloak: Keycloak;
	initOptions: KeycloakInitOptions;
	loginOptions: KeycloakLoginOptions;
}

export default createContext<IKeycloakContext>({
	isAuthenticated: false,
	keycloak: {} as Keycloak,
	initOptions: {},
	loginOptions: {},
});
